import React from 'react';
import { FunctionComponent } from 'react';
import { Field } from '../../Field/Field';
import { FieldContainer, Label, Select } from '../../Components';
import { Validator } from '../../Field';
import styles from './styles.module.scss';

export type DropdownFieldProps = {
    id?: string;
    name: string;
    label: string;
    description?: string;
    options: Array<{ value: string; label: string }>;
    initialValue?: string;
    onBlurValidate?: Validator<string | null>;
    onChangeValidate?: Validator<string | null>;
    onSubmitValidate?: Validator<string | null>;
    required?: boolean;
    disabled?: boolean;
};

export const DropdownField: FunctionComponent<DropdownFieldProps> = ({
    id,
    name,
    label,
    description,
    options,
    initialValue,
    onBlurValidate,
    onChangeValidate,
    onSubmitValidate,
    required = false,
    disabled,
}) => {
    return (
        <Field<string | null>
            id={id}
            name={name}
            description={description}
            initialValue={initialValue}
            onBlurValidate={onBlurValidate}
            onChangeValidate={onChangeValidate}
            onSubmitValidate={onSubmitValidate}
            required={required}
        >
            {({
                fieldId,
                value,
                setValue,
                onBlur,
                isValid,
                errors,
                errorId,
                descriptionId,
                required,
                requiredStrategy,
            }) => {
                return (
                    <FieldContainer
                        errorId={errorId}
                        errors={errors}
                        descriptionId={descriptionId}
                        description={description}
                    >
                        <Label
                            id={`${fieldId}-label`}
                            className={styles.label}
                            required={required}
                            requiredStrategy={requiredStrategy}
                        >
                            {label}
                        </Label>
                        <Select
                            id={fieldId}
                            options={options}
                            onChange={(newValue) => setValue(newValue?.value || null)}
                            value={value}
                            onBlur={onBlur}
                            aria-invalid={!isValid}
                            aria-errormessage={errorId}
                            aria-describedby={descriptionId}
                            aria-labelledby={`${fieldId}-label`}
                            isClearable={true}
                            disabled={disabled}
                        />
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
